
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Modal } from "react-bootstrap";
import { QueryListProvider } from "../../../../component/solution/QueryTableList/QueryListContext";
import { QueryTableList } from "../../../../component/solution/QueryTableList/QueryTableList";
import { useAuth } from "../../../../contexts/AuthContext";
import { IntegrationStatus, IQuerySelectData, IQueryTableData } from "../../../../component/solution/Interfaces";
import { AlertTriangle, Ban, Bell, CheckCircle, ChevronDown, ChevronUp, RotateCcw } from "lucide-react";
import { formatDateFull } from "../../../../component/solution/utils/AppUtil";


// export interface IReturnRequestFailedTransaction {
//     m24l_reference: string,
//     function_call_id: string, 
//     extended_message: string | null, 
//     completed_at: string,
//     created: string, 
// }

export const ReturnRequest: React.FC = () => {

    const { fetchData, userDetail, setRefreshTable } = useAuth();
    const navigate = useNavigate();
    
    const [showModal, setShowModal] = useState(false);
    const [modalLayout, setModalLayout] = useState<React.ReactNode | null>(null);
    const [modalData, setModalData] = useState<{ modalTitle: string; modalSubtitle: string } | null>(null);

    const [showCancelTransactionModal, setShowCancelTransactionModal] = useState<boolean>(false);
    const [cancelledTransactionData,  setCancelledTransactionData] = useState<{ 
        user_id: string, 
        document_number: string, 
        document_type: string, 
        transaction_number: string, 
        title: string
    } | null>(null); 
    

//     const { fetchData, userDetail } = useAuth();
//     const queryUrlSelectNoCount: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data"}`;

//     const defaultSelectedReturnRequestFailedTransaction = { m24l_reference: "", function_call_id: "", extended_message: "", completed_at: "",  created: "" }; 

//     const [returnRequestFailedTransactionsData, setReturnRequestFailedTransactionsData] = useState<IReturnRequestFailedTransaction[]>([]);
//     const [selectedReturnRequestFailedTransaction, setSelectedReturnRequestFailedTransaction] = useState<IReturnRequestFailedTransaction>(defaultSelectedReturnRequestFailedTransaction);
//     const [returnRequestFailedTransactionsRerunModal, setReturnRequestFailedTransactionsRerunModal] = useState<boolean>(false);
//     const [returnRequestFailedTransactionsHandledModal, setReturnRequestFailedTransactionsHandledModal] = useState<boolean>(false);
//     const [submitRefreshData, setSubmitRefreshData] = useState<boolean>(false); 
//     const [expanded, setExpanded] = useState(false);

//     // -> failed transactions -> return request 
//     const defaultQueryStateFailedTransactionsReturnRequest: IQuerySelectData = {
//         appCode: "ares",
//         selectCode: "sa-m24l-return-request",  
//         where: `handled_status IS NOT DISTINCT FROM :handled_status`,  
//         params: {'handled_status': "REQUIRED"}
           
//     }; 
//     const [querySelectStateFailedReturnRequest, setQuerySelectStateFailedReturnRequest] = useState<IQuerySelectData>(defaultQueryStateFailedTransactionsReturnRequest);

//     useEffect(() => {
//         if (userDetail?.roles) {
//             fetchData(queryUrlSelectNoCount, { method: "POST", body: JSON.stringify(querySelectStateFailedReturnRequest) }, processDataFailedStockAdjustment);
//         }
//     }, [userDetail?.roles, submitRefreshData]); // expanded


//     // failed transactions for return requests
//     const processDataFailedReturnRequest = (result: any) => {

//         const returnRequestFailedTransactions: IReturnRequestFailedTransaction[] = [];

//         for (const key in result?.data) {
//             const item = result.data[key];
//             if (item?.data) {
//                 returnRequestFailedTransactions.push(item.data as IReturnRequestFailedTransaction);
//             }
//         }
        
//         returnRequestFailedTransactions.sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime());
    
//         // Collapse table secion if empty reset expand
//         if (returnRequestFailedTransactions.length === 0) {
//             setExpanded(false);
//         }
    
//         setReturnRequestFailedTransactionsData(returnRequestFailedTransactions);
//     }


//     //handle sumbit for return request rerun 
//     const handleFailedReturnRequestRerunSubmit = () => {
//         if(selectedReturnRequestFailedTransaction?.m24l_reference !== "" && selectedReturnRequestFailedTransaction?.function_call_id !== ""){
//             fetchData(`${process.env.REACT_APP_BASE_URL}/functionCalls/${selectedReturnRequestFailedTransaction?.function_call_id}/rerun`, 
//             {method:"POST", body: JSON.stringify({ })}, 
//             (result: any, status: string) =>  { 
//                 if(status === "200"){
//                     setSelectedReturnRequestFailedTransaction(defaultSelectedReturnRequestFailedTransaction);
//                     setSubmitRefreshData(prev => !prev); //trigger refresh on success 
//                 }else{
//                     setSelectedReturnRequestFailedTransaction(defaultSelectedReturnRequestFailedTransaction);
//                 }
//             });
//         } else {
//             return; 
//         }
//     }

//     //handle sumbit for return request handled 
//     const handleFailedReturnRequestHandledSubmit = () => {
//          if(selectedReturnRequestFailedTransaction?.m24l_reference !== "" && selectedReturnRequestFailedTransaction?.function_call_id !== ""){
//             fetchData(`${process.env.REACT_APP_BASE_URL}/functionCalls/${selectedReturnRequestFailedTransaction?.function_call_id}/handle`, 
//             {method:"POST", body: JSON.stringify({ })}, 
//             (result: any, status: string) =>  { 
//                 if(status === "200"){
//                     setSelectedReturnRequestFailedTransaction(defaultSelectedReturnRequestFailedTransaction);
//                     setSubmitRefreshData(prev => !prev); //trigger refresh on success 
//                 }else{
//                    setSelectedReturnRequestFailedTransaction(defaultSelectedReturnRequestFailedTransaction);
//                 }
//             });
//         } else {
//             return; 
//         }
//     }

//     const FailedTransactionsHeader = (
//         returnRequestFailedTransactionsData.length > 0 && 
//         <button className="btn p-1 d-flex align-items-center justify-content-center" title={expanded ? "Hide failed transactions" : "Show failed transactions"} onClick={() => setExpanded(prev => !prev)} 
//             style={{ border: "1px solid #c10000", background: "transparent", borderRadius: "50%", color: "#c10000", width: "22px", height: "22px"}}
//         >
//           {expanded ? ( <ChevronUp size={20} strokeWidth={2.2} /> ) : ( <ChevronDown size={20} strokeWidth={2.2} />)}
//         </button>
//     );


//       const thNewStyle = {
//         borderBottom: "1px solid #dee6ed",
//         borderRight: "1px solid #dee6ed",
//         borderTop: "1px solid #dee6ed",
//         color: "#6c757d",
//         padding: "8px",
//         whiteSpace: "nowrap" as const,
//         backgroundColor: "#f8f9fa",
//     };

//     const tdStyle = {
//         borderBottom: "1px solid #dee6ed",
//         borderRight: "1px solid #dee6ed",
//         padding: "8px",
//         whiteSpace: "nowrap" as const,
//     };

    
//    const FailedTransactionsSection: React.FC<{ 

//         data: IReturnRequestFailedTransaction[];
//         expanded: boolean;
//         toggleExpanded: () => void;

//         selectedTransaction: IReturnRequestFailedTransaction;
//         showRerunModal: boolean;
//         showHandledModal: boolean;

//         onRerunClick: (tx: IReturnRequestFailedTransaction) => void;
//         onHandledClick: (tx: IReturnRequestFailedTransaction) => void;
//         onRerunConfirm: () => void;
//         onHandledConfirm: () => void;
//         onRerunCancel: () => void;
//         onHandledCancel: () => void;

//     }> = ({

//         data,
//         expanded,
//         selectedTransaction,
//         showRerunModal,
//         showHandledModal,
//         onRerunClick,
//         onHandledClick,
//         onRerunConfirm,
//         onHandledConfirm,
//         onRerunCancel,
//         onHandledCancel,

//     }) => {
//         if (!data?.length) return null;

//         return (
//             <>
//                 {expanded && (
//                     <div style={{border: "1px solid #c10000" , padding: '0px 4px', marginBottom: '14px', marginTop: '14px', borderRadius: '5px'}}>
//                          <h5 className="mt-2 mb-2 text-uppercase text-secondary fw-bolder border-bottom pb-1">
//                             Failed Transactions: 
//                         </h5>
//                         <div style={{
//                             maxHeight: returnRequestFailedTransactionsData.length > 10 ? "450px" : "unset", 
//                             overflowY: returnRequestFailedTransactionsData.length > 10 ? "auto" : "visible",
//                             marginBottom: "4px",
//                             position: "relative",
//                             backgroundColor: "#fff", 
//                             borderBottom: "1px solid #dee6ed",
//                         }}
//                         >
//                         <table className="table table-bordered  mb-0" style={{ borderCollapse: "separate", borderSpacing: 0, width: "100%" }}>
//                             <thead className="table-light" style={{ position: "sticky", top: 0, zIndex: 10, backgroundColor: "#f8f9fa", boxShadow: "0 2px 2px -1px rgba(0, 0, 0, 0.05)"}}>
//                                 <tr>
//                                     <th style={{ ...thNewStyle, width: "160px"}}>M24l Reference</th>
//                                     <th style={thNewStyle}>Message</th>
//                                     <th style={thNewStyle}>Last Run</th>
//                                     <th style={{ ...thNewStyle, width: "100px"}}> Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                             {data.map((tx, index) => (
//                                 <tr key={index}>
//                                     <td style={tdStyle}>{tx.m24l_reference}</td>
//                                     <td title={tx.extended_message ?? ""} style={{...tdStyle, maxWidth: "300px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",}} >
//                                         {tx.extended_message}
//                                     </td>
//                                     <td style={tdStyle}>{formatDateFull(tx.completed_at ?? "")}</td>
//                                     <td style={{...tdStyle}} className="d-flex gap-1">
//                                         <button className="btn btn-secondary d-flex align-items-center gap-1" title="Rerun" onClick={() => onRerunClick(tx)}>
//                                             <RotateCcw  style={{ width: "17px", height: "17px" }}/>
//                                         </button>
//                                         <button className="btn btn-secondary d-flex align-items-center gap-1" title="Handled" onClick={() => onHandledClick(tx)}>
//                                             <CheckCircle style={{ width: "17px", height: "17px" }} />
//                                         </button>
//                                     </td>
//                                 </tr>
//                                 )) }
//                             </tbody>
//                         </table>
//                     </div>
//                     <div style={{marginBottom: "3px", marginLeft: "10px", color: "#c10000" }}>
//                         <small className="text-muted fw-bolder">Total Failed Transactions: {data.length}</small>
//                     </div>                       
//                  </div>
//                 )}

        
//                 <Modal show={showRerunModal} onHide={onRerunCancel}>
//                     <Modal.Header closeButton>
//                         <Modal.Title>{`Rerun Failed [${selectedTransaction?.m24l_reference}] Transaction`}</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <p>Are you sure you would like to rerun this transaction?</p>
//                     </Modal.Body>
//                     <Modal.Footer>
//                         <Button variant="primary" onClick={onRerunConfirm}>Confirm</Button>
//                         <Button variant="secondary" onClick={onRerunCancel}>Cancel</Button>
//                     </Modal.Footer>
//                 </Modal>

               
//                 <Modal show={showHandledModal} onHide={onHandledCancel}>
//                     <Modal.Header closeButton>
//                         <Modal.Title>{`Handle Failed [${selectedTransaction?.m24l_reference}] Transaction`}</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <p>Are you sure you would like to mark this transaction as handled?</p>
//                     </Modal.Body>
//                     <Modal.Footer>
//                         <Button variant="primary" onClick={onHandledConfirm}>Confirm</Button>
//                         <Button variant="secondary" onClick={onHandledCancel}>Cancel</Button>
//                     </Modal.Footer>
//                 </Modal>
//             </>
//         );
//     };

//     const FailedTransactionsBody = (
//         <FailedTransactionsSection
//             data={returnRequestFailedTransactionsData}
//             expanded={expanded}
//             toggleExpanded={() => setExpanded(prev => !prev)}
//             selectedTransaction={selectedReturnRequestFailedTransaction}
//             showRerunModal={returnRequestFailedTransactionsRerunModal}
//             showHandledModal={returnRequestFailedTransactionsHandledModal}
//             //handle return request rerun click
//             onRerunClick={(tx) => {
//                 setSelectedReturnRequestFailedTransaction(tx);
//                 setReturnRequestFailedTransactionsRerunModal(true);
//             }}
//             //handle return request handle click
//             onHandledClick={(tx) => {
//                 setSelectedReturnRequestFailedTransaction(tx);
//                 setReturnRequestFailedTransactionsHandledModal(true);
//             }}
//             //handle sumbit for return request rerun [SUBMIT]
//             onRerunConfirm={() => {
//                 handleFailedReturnRequestRerunSubmit();
//                 setReturnRequestFailedTransactionsRerunModal(false);
//             }}
//             ////handle sumbit for return request handled [SUBMIT]
//             onHandledConfirm={() => {
//                 handleFailedReturnRequestHandledSubmit();
//                 setReturnRequestFailedTransactionsHandledModal(false);
//             }}
//             //handle return request rerun reset click [RESET]
//             onRerunCancel={() => {
//                 setSelectedReturnRequestFailedTransaction(defaultSelectedReturnRequestFailedTransaction);
//                 setReturnRequestFailedTransactionsRerunModal(false);
//             }}
//             //handle return request handled reset click [RESET]
//             onHandledCancel={() => {
//                 setSelectedReturnRequestFailedTransaction(defaultSelectedReturnRequestFailedTransaction);
//                 setReturnRequestFailedTransactionsHandledModal(false);

//             }}
//         />
//     );

    const getStatusColor = (status: string): { backgroundColor: string; color: string; } | {} => {
        if (IntegrationStatus[status as keyof typeof IntegrationStatus]) {
            return { backgroundColor: IntegrationStatus[status as keyof typeof IntegrationStatus], color: 'white' };
        }
        return {};
    };


    const openModal = (docNum: string) => {
        fetchDetailedSummary(docNum); 
    }
   
    const clearModalHistory = () => {
        setShowModal(false); 
        setModalLayout(null); 
        setModalData(null);
    }
   
    const fetchDetailedSummary = async (docNum: string) => {
               
        const querySummaryUrl = `${process.env.REACT_APP_BASE_URL}/table/sa_m24l_return_request_line/data?includeCount=true`;
    
        const tableSummaryQuery: IQueryTableData = {
            tableName: "sa_m24l_return_request_line",
            where: 'doc_num = :doc_num',
            orderBy: 'item_code ASC',
            pageNum: 0,
            pageSize: 0,
            params: { 'doc_num': `${docNum}`}
        }; 

        fetchData(querySummaryUrl, {method:"POST", body: JSON.stringify(tableSummaryQuery)}, (result: any) =>  processSummary(result, docNum));
        setShowModal(true);
    }
   

    // Process the Result into a table for display purposes.
    const processSummary = (result: any, docNum: string) => {

        const detail = result.data;
        const { summaryTable, detailTable } = generateDetailTables(detail);

        // Set the layout for the modal
        setModalLayout(
            <div className="d-flex flex-column gap-3" >
            <div style={{background:"#f2f5f3"}} className="p-2">
                <h6 className="text-secondary fw-bolder">
                    Summary
                </h6>
                <div className="mb-3">{summaryTable}</div>
            </div>

            <div style={{background:"#f2f5f3"}} className="p-2">
                <h6 className="text-secondary fw-bolder">
                    Line Details
                </h6>
                <table className="table" style={{ border: '1px solid #adb5bd' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #adb5bd' }}>Line No.</th>
                            <th style={{ border: '1px solid #adb5bd' }}>Item Code</th>
                            <th style={{ border: '1px solid #adb5bd' }}>Handling Unit</th>
                            <th style={{ border: '1px solid #adb5bd' }}>Warehouse Code</th>
                            <th style={{ border: '1px solid #adb5bd' }}>Qty Ordered</th>
                            <th style={{ border: '1px solid #adb5bd' }}>Qty Received</th>
                        </tr>
                    </thead>
                    <tbody>{detailTable}</tbody>
                </table>
            </div>
        </div>
        );

        setModalData({ modalTitle: `Doc Num: [${docNum}]`, modalSubtitle: `Inbound - Return Request:` });
        setShowModal(true);
    };


    // generate detailed table for selected document
    const generateDetailTables = (detail: any[]) => {

        const detailTable: React.ReactElement[] = [];
        let totalQuantityOrdered = 0;
        let totalQuantityReceived = 0;

        // Sort by line_num ascending before rendering
        const sortedDetail = [...detail].sort((a, b) => {
            const aLine = a.data?.line_num ?? 0;
            const bLine = b.data?.line_num ?? 0;
            return aLine - bLine;
        });

        sortedDetail.forEach((item, idx) => {
            const data = item.data;
            totalQuantityOrdered += data?.qty_ordered ?? 0;
            totalQuantityReceived += data?.qty_received ?? 0;

            detailTable.push(
            <tr key={idx}>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.line_num}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.item_code}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.handling_unit}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.warehouse_code}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.qty_ordered}</td>
                <td className="text-center" style={{ border: '1px solid #adb5bd' }}>{data?.qty_received}</td>
            </tr>
            );
        });

        const summaryTable = (
            <table className="table w-auto" style={{ border: '1px solid #adb5bd' }}>
            <tbody>
                <tr>
                    <th style={{ width: '150px', border: '1px solid #adb5bd' }}>Unique Item Total</th>
                    <td style={{ width: '100px',  border: '1px solid #adb5bd' }} className="text-end">{detail.length}</td>
                </tr>
                    <tr>
                    <th style={{ width: '150px', border: '1px solid #adb5bd' }}>Total Qty Ordered</th>
                    <td style={{ width: '100px',  border: '1px solid #adb5bd' }} className="text-end">{totalQuantityOrdered}</td>
                </tr>
                <tr>
                    <th style={{ width: '150px', border: '1px solid #adb5bd' }}>Total Qty Recieved</th>
                    <td style={{ width: '100px',  border: '1px solid #adb5bd' }} className="text-end">{totalQuantityReceived}</td>
                </tr>
            </tbody>
        </table>
        );

        return { summaryTable, detailTable };
    };

    //CANCEL TRASCATION SECTION 
    const openModalValidTransaction = (user_id: string, document_number: string, document_type: string, transactionNumber: string, title: string) => {
        if (user_id === "" || document_number === "" || document_type === "") return;
        setCancelledTransactionData({ user_id: user_id, document_number: document_number, document_type: document_type, transaction_number: transactionNumber, title: title}); 
        setShowCancelTransactionModal(true); 
    }


    //handle canceld transaction
    const handleCancelTransaction = (user_id: string, document_number: string, document_type: string, transaction_number: string) => {

        if (user_id === "" || document_number === "" || document_type === "") return;
 
        // form data to be posted
        const formData  = { 
            user_id: user_id, 
            document_number: document_number, 
            document_type: document_type, 
            transaction_number: transaction_number 
        };

        fetchData(`${process.env.REACT_APP_BASE_URL}/functions/CANCEL-DOCUMENT/run`, 
        {method:"POST", body: JSON.stringify(formData)}, 
        (result: any, status: string) =>  { 
            if(status === "200"){
              setRefreshTable(prev => !prev);
            }
        });
    }

    const clearCancelTransactionModal = () => {
        setShowCancelTransactionModal(false); 
        setCancelledTransactionData(null);
    }


    /* 
     Status 

     Inbound - Return Request
        TO_SEND - Document ready to be sent to M24L.
        SENT - Doument has has been sent to M24L for processing.
        SUCCESS - Document successfully received at M24L for processing.
        ERROR - There was a problem integrating the document at M24L.
        ARRIVED - Shipment has arrived at M24L.
        CLOSED - Document processing complete.
        CANCELLED - Document has been cancelled. 
    */

    /* 
      [Table Rows & Order To Display]: 
        doc_num  
        doc_type  
        division  
        rma_num  
        card_code  
        card_name  
        num_at_card  
        integration_status  
        total_qty  
        comments  
        created  
        updated
    */


    return(
        <React.Fragment>
            <Container fluid className="p-0">
            <QueryListProvider>
                    <QueryTableList
                        listTitle={"Inbound - Return Requests"}
                        recordTitle={"Inbound - Return Requests"}
                        tableName={"sa_m24l_return_request"}
                        editTableName={"sa_m24l_return_request"}
                        hasIntegrationStatusLegend={true} 
                        errorCategoryName={'ReturnRequest'}
                        integrationstatusLegend={[
                            { status: 'ERROR', color: '#bf3636', description: 'There was a problem integrating the document at M24L.'},
                            { status: 'CANCELLED', color: '#8b8b8c', description: 'Document has been cancelled.'},
                            { status: 'TO_SEND', color: '#d4a53f', description: 'Document ready to be sent to M24L.'},
                            { status: 'ARRIVED', color: '#d4a53f', description: 'Shipment has arrived at M24L.'},
                            { status: 'SENT', color: '#d4a53f', description: 'Document has been sent to M24L for processing.'},
                            { status: 'SUCCESS', color: '#d4a53f', description: 'Document successfully received at M24L for processing.'},
                            { status: 'CLOSED', color: '#3ec76b', description: 'Document processing complete.'}
                        ]}
                        editHasCompoundKey={false}  
                        showFailedTransactionsTable={false}
                        query={{
                              appCode: "ares",
                              selectCode: "return-request-notification-projection",
                              tableName: null, 
                              where: "",
                              orderBy: "",
                              pageNum: 0,
                              pageSize: 100,
                              params: {},
                        }}   
                        orderColumns={[
                            { name: "doc_num", type: "INTEGER", sortable: true, searchable: true },
                            { name: "doc_type", type: "VARCHAR", sortable: true, searchable: true },
                            { name: "division", type: "VARCHAR", sortable: true, searchable: true },
                            { name: "rma_num", type: "VARCHAR", sortable: true, searchable: true },
                            { name: "card_code", type: "VARCHAR", sortable: true, searchable: true },
                            { name: "card_name", type: "VARCHAR", sortable: true, searchable: true },
                            { name: "num_at_card", type: "VARCHAR", sortable: true, searchable: true },
                            { name: "integration_status", type: "VARCHAR", sortable: true, searchable: true },
                            { name: "total_qty", type: "INTEGER", sortable: true, searchable: true },
                            { name: "comments", type: "VARCHAR", sortable: true, searchable: true },
                            { name: "created", type: "TIMESTAMP", sortable: true, searchable: false },
                            { name: "updated", type: "TIMESTAMP", sortable: true, searchable: false }
                        ]}
                        reportOptions={{ 
                            reportQuery: {
                              appCode: "ares",
                              selectCode: "return-request-with-line",
                              tableName: null, 
                              where: "",
                              orderBy: "",
                              pageNum: 0,
                              pageSize: 0,
                              params: {},
                            },
                            templateName: "apps/ares/return_request_template.xlsx", 
                            reportName: "return_request_report.xlsx",
                            reportData: null
                        }}      
                        renderRowData={(row) => {
                        
                            const tdStyle: React.CSSProperties = { whiteSpace: 'nowrap', border: '1px solid #deebed',  padding: '4px 8px', fontSize: '0.75rem' };
                            const statusColor = getStatusColor(row.integration_status); 
                            const tdEllipsis: React.CSSProperties = {...tdStyle, maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}
                            const tdHasDetailsOption: React.CSSProperties = { ...tdStyle,  textDecoration: 'underline', cursor: 'pointer'};

                            return (
                                <>
                                    <td style={tdHasDetailsOption} title={row.doc_num}>
                                         <span onClick={() => openModal(row.doc_num)}>{row.doc_num}</span>
                                    </td>
                                    <td style={tdStyle} title={row.doc_type}>{row.doc_type}</td>
                                    <td style={tdStyle} title={row.division}>{row.division}</td>
                                    <td style={tdStyle} title={row.rma_num}>{row.rma_num}</td>
                                    <td style={tdStyle} title={row.card_code}>{row.card_code}</td>
                                    <td style={tdStyle} title={row.card_name}>{row.card_name}</td>
                                    <td style={tdStyle} title={row.num_at_card}>{row.num_at_card}</td>
                                    <td style={{...tdStyle,...statusColor, textAlign: "center", verticalAlign: "middle"}} title={row.integration_status}>
                                        {row.integration_status}
                                    </td>
                                    <td style={tdStyle} title={row.total_qty}>{row.total_qty}</td>
                                    <td style={tdEllipsis} title={row.comments}>{row.comments}</td>
                                    <td style={tdStyle} title={formatDateFull(String(row.created))}>{formatDateFull(String(row.created))}</td>
                                    <td style={tdStyle} title={formatDateFull(String(row.updated))}>{formatDateFull(String(row.updated))}</td>
                                </>    
                            );
                        }}

                        renderActions={(row) => {

                            //checking has error notification
                            const numericRefValue = Number(row.num_notifications);
                            const shouldShowErrorButton = numericRefValue > 0 && row.integration_status !== "CLOSED";

                            //checking last updated 
                            const updatedAtValue = row.updated; 
                            const createdAtValue = row.created;
                            const baseDateStr = typeof updatedAtValue === "string" && updatedAtValue.trim() ? updatedAtValue : typeof createdAtValue === "string" && createdAtValue.trim() ? createdAtValue : null;
                            const baseDate = baseDateStr ? new Date(baseDateStr).getTime() : null;
                            const isStaleUpdate = baseDate !== null && row.integration_status !== "CLOSED" && Date.now() - baseDate > 12 * 60 * 60 * 1000; // 12 hours

                            //can cancel transaction  
                            const hasCancelPermission = userDetail?.roles?.includes("cancel_documents");
                            const invalidCancelStatuses = ["CLOSED", "CANCELLED", "ERROR", "PROCESSED"];
                            const hasStatusCancelPermission = !invalidCancelStatuses.includes(String(row.integration_status));
                            const canCancelTransaction = hasCancelPermission && row.doc_num && hasStatusCancelPermission;

                            return (
                              <td className="sa-record-control" style={{ border: '1px solid #deebed', height: '45px', fontSize: '0.55rem', padding: '0 5px'}}>
                                <div className="d-flex gap-2">

                                 {shouldShowErrorButton && row.doc_num && (
                                    <button className="btn btn-light position-relative" title="View On Error Notifications"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          navigate('/m24l/notifications-new', { state: { shipment_num: row.doc_num as string, category: 'ReturnRequest'}});
                                        }}
                                        style={{ width: '32px', height: '32px', padding: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', border:'1px solid #dbdad9' }}
                                    >
                                        <span className="position-absolute top-0 end-0" style={{ fontSize: "0.60rem" , paddingRight: '2px', color: '#f7633e', fontWeight:'600' }}>
                                            {numericRefValue}
                                        </span>
                                        <Bell style={{ width: "15px", height: "15px", color:'#343a40', position: 'absolute', top: '60%', transform: 'translateY(-6px)' }} />
                                    </button>
                                 )}

                                {isStaleUpdate && row.doc_num && (
                                    <button className="btn btn-light" title="Last update was over 12 hours ago"
                                        style={{ width: '32px', height: '32px', padding: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', border: '1px solid #dbdad9' }}
                                    >
                                        <AlertTriangle color="#4d1302" size={16} />
                                    </button>
                                )}

 
                                {canCancelTransaction && row.doc_num && (
                                 <button className="btn btn-light" title="Cancel Transaction"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          openModalValidTransaction( userDetail?.id ?? "", String(row.doc_num), 'return_request', String(row.transaction_num ?? ""), "Inbound - Return Requests")
                                        }}
                                        style={{ width: '32px', height: '32px', padding: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', border: '1px solid #dbdad9' }}
                                    >
                                        <Ban color="#4d1302" size={16} />
                                 </button>
                                )}
                              </div>   
                            </td>
                            );
                        }}   
                    />
                </QueryListProvider>

                { /* open modal detailed view [start] */ }
                <Modal show={showModal} onHide={clearModalHistory} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{`${modalData?.modalTitle}`}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h5 className="text-uppercase text-secondary fw-bolder pb-1">{modalData?.modalSubtitle}</h5>
                        {modalLayout}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={clearModalHistory}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                { /* open modal detailed view [end] */ }


                { /* open modal cancel transaction [start] */ }
               <Modal show={showCancelTransactionModal} onHide={clearCancelTransactionModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{ cancelledTransactionData?.title }: [ { cancelledTransactionData?.document_number } ]</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <div className="informational-message-section">
                            <p>
                                <strong>Note:</strong> You are about to <strong>cancel this transaction</strong>. 
                                Clicking <strong>Confirm</strong> will permanently cancel the record and any associated processes. 
                                Closing this modal or clicking <strong>Cancel</strong> will <strong>abort the cancellation</strong> and leave the transaction unchanged.
                            </p>
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="primary" onClick={() => { 
                            setShowCancelTransactionModal(false); 
                            handleCancelTransaction(
                                cancelledTransactionData?.user_id ?? "", 
                                cancelledTransactionData?.document_number ?? "", 
                                cancelledTransactionData?.document_type ?? "",
                                cancelledTransactionData?.transaction_number ?? ""
                            ); 
                            setCancelledTransactionData(null);
                        }}
                        >
                            Confirm
                        </Button>
                        <Button variant="secondary" onClick={clearCancelTransactionModal}>
                            Cancel
                        </Button>
                        </Modal.Footer>
                    </Modal>
                { /* open modal open modal cancel transaction [end] */ }
                
            </Container>
        </React.Fragment>
    );
}

